import { render } from "./RoleCatalogue.vue?vue&type=template&id=615544d7&ts=true"
import script from "./RoleCatalogue.vue?vue&type=script&lang=ts"
export * from "./RoleCatalogue.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__